<template>
<div>
  <div class="mr-r30" style="width:360px; float:left;">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">관리 대상</span>
        <el-select  class="mr-r4" style="width: 150px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper ref="eventObjTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadEventObjTable" highlight-current-row
    row-class-name="c-pointer" :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true" @cell-click="selectTargetObjInfo"  remote :total="total">
    </el-table-wrapper>
  </div>
  <w-obj-event-alarm-set-table style="width:calc(100% - 390px); float:right;" :isOnlyPredictRscList="true" :obj="obj" :show-script-set="false" :is-setting-popup="true" :has-auth="true"/>
</div>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import WObjEventAlarmSetTable from '@/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/components/ObjEventAlarmSetTable';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';

export default {
  name: 'WEventAlarmSetting',
  components: {
    WObjEventAlarmSetTable,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      obj: null,
      setTargetObjList: [],
      total: 0,
      showSearchTool: false,
      targetObjParams: {
        objId: null,
        objDefineId: null,
      },
      objDefineId: null,
      loading: false,
      objDefineList: [],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
    };
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadEventObjTable();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (this.activeTab === 'WEventAlarmSetting') {
        this.objDefineId = null;
        this.loadPredictTargetData();
      }
    },
    /**
     * 관리 대상 선택 이벤트 핸들러
     * @author Ju
     * @param  {object} node
     */
    selectNode(node) {
      this.obj = node.obj;
    },
    /**
     * 이벤트 예측 자원 목록을 조회한다.
     * @author yelim
     * @return {[type]}
     */
    loadEventObjTable() {
      const tableParams = this.$refs.eventObjTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventPredictSettingsAPI.getPredictTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.selectTargetObjInfo(this.setTargetObjList[0]);
          this.$refs.eventObjTable.getTable().setCurrentRow(this.setTargetObjList[0]);
          this.total = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    loadPredictTargetData() {
      EventPredictSettingsAPI.getPredictTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 조회할 obj를 선택한다.
     * @author yelim
     * @param  {[type]} row [description]
     */
    selectTargetObjInfo(row) {
      this.obj = row;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/EventAlarmSetting/index.vue